import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {Experiments} from '@wix/yoshi-flow-editor'
import {State} from '../types/state'

export const getEventsSettings = (state: State) => state.eventsSettings

export const isWixFormsEnabled = (state: State, experiments: Experiments) =>
  !!getEventsSettings(state).wixFormsEnabled || experiments.enabled(ExperimentNames.UseWixForms)
